/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      anyOf: [
        {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            url: {
              type: 'string',
            },
          },
          required: ['id', 'url'],
        },
        {
          type: 'object',
          maxProperties: 0,
        },
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    webshop_company_video_file: valueSchema,
  },
}
